import React from "react";
import { nth, pluralizeText } from "../../../lib/utils";

export default class PrizeList extends React.PureComponent {
  render() {
    const {
      // hasCashPrizeDisclaimer,
      onPrizeClick,
      prizes,
      raffleTitle,
      winners,
    } = this.props;

    return (
      <div className="flex flex-justify-center mb-32 mobile-mb-0">
        {!prizes.length ? (
          <p className="text-center accent-text large-text">
            No Prizes Listed for {raffleTitle}
          </p>
        ) : (
          <div className={`prizes-grid${prizes.length === 1 ? " block" : ""}`}>
            {prizes.map((prize, index) => {
              const prizeWinners = winners?.filter(
                (winner) => winner.rafflePrizeID === prize.id
              );
              return (
                <div className="prize" key={index} onClick={onPrizeClick}>
                  <p className="prize-place">
                    {prizes.length > 1 &&
                      (prize.place === 1
                        ? "Grand Prize"
                        : `${prize.place}${nth(prize.place)} prize`)}
                  </p>
                  <p className="prize-title">{prize.title}</p>
                  {winners?.length ? (
                    <p className="prize-winner-name">
                      {prize.numberOfWinners === 1 ? "Winner: " : ""}
                      {prizeWinners.map((winner, i) => (
                        <span>
                          {winner.firstName} {winner.lastName}
                          {i + 1 < prizeWinners.length ? " • " : ""}
                        </span>
                      ))}
                    </p>
                  ) : (
                    <p className="prize-winner-amount">
                      {prize.numberOfWinners}{" "}
                      {pluralizeText("Winner", prize.numberOfWinners)}
                    </p>
                  )}
                  {prize.prizeImageURL && !winners && (
                    <img
                      className="prize-img"
                      src={prize.prizeImageURL}
                      alt={prize.title}
                    />
                  )}
                </div>
              );
            })}
            {/* Hidden for Raffle 2023
                   {hasCashPrizeDisclaimer && (
                  <p className="cash-prize-disclaimer-asterisk">*</p>
                )} */}
          </div>
        )}
      </div>
    );
  }
}
